import script from "./ClientCabinetList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetList.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetList.vue?vue&type=style&index=0&id=13f6d5c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f6d5c4"]])

export default __exports__